var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5291 15.2322L20.4551 19.1573L19.1581 20.4544L15.2329 16.5283C13.7724 17.6991 11.9558 18.3359 10.084 18.3333C5.52998 18.3333 1.83398 14.6373 1.83398 10.0833C1.83398 5.52925 5.52998 1.83325 10.084 1.83325C14.638 1.83325 18.334 5.52925 18.334 10.0833C18.3366 11.9551 17.6999 13.7717 16.5291 15.2322ZM14.6902 14.552C15.8536 13.3556 16.5033 11.752 16.5006 10.0833C16.5006 6.53758 13.6287 3.66659 10.084 3.66659C6.53832 3.66659 3.66732 6.53758 3.66732 10.0833C3.66732 13.628 6.53832 16.4999 10.084 16.4999C11.7527 16.5025 13.3564 15.8529 14.5527 14.6895L14.6902 14.552Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearch);
export default __webpack_public_path__ + "static/media/white_search.3f9fd413c975ef7d8227f910921d9a90.svg";
export { ForwardRef as ReactComponent };